import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "panel", "count", "decrement", "hiddenInput"]
  static values = { labels: Object }

  // Categories come from CampSite::GUEST_CATEGORIES, serialized server-side into labelsValue
  get categories() {
    return Object.keys(this.labelsValue)
  }

  connect() {
    this.boundClickOutside = this.closeOnClickOutside.bind(this)
    this.boundEscape = this.closeOnEscape.bind(this)
    document.addEventListener("click", this.boundClickOutside)
    document.addEventListener("keydown", this.boundEscape)
    this.updateDisplay()
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
    document.removeEventListener("keydown", this.boundEscape)
  }

  open(event) {
    if (event) event.stopPropagation()
    this.panelTarget.classList.remove("hidden")
  }

  close() {
    this.panelTarget.classList.add("hidden")
  }

  confirm() {
    this.close()
  }

  reset() {
    this.categories.forEach((category) => this.setCount(category, 0))
  }

  increment(event) {
    const category = event.currentTarget.dataset.category
    const next = this.currentCount(category) + 1
    this.setCount(category, next)
  }

  decrement(event) {
    const category = event.currentTarget.dataset.category
    const next = Math.max(0, this.currentCount(category) - 1)
    this.setCount(category, next)
  }

  setCount(category, value) {
    const hiddenInput = this.hiddenInputFor(category)
    if (hiddenInput) hiddenInput.value = String(value)

    const counter = this.countTargets.find((el) => el.dataset.category === category)
    if (counter) counter.textContent = String(value)

    const decrementBtn = this.decrementTargets.find((el) => el.dataset.category === category)
    if (decrementBtn) decrementBtn.disabled = value <= 0

    this.updateDisplay()
  }

  currentCount(category) {
    const input = this.hiddenInputFor(category)
    return input ? parseInt(input.value, 10) || 0 : 0
  }

  hiddenInputFor(category) {
    return this.hiddenInputTargets.find((el) => el.dataset.category === category) || null
  }

  updateDisplay() {
    const parts = this.categories
      .map((category) => [category, this.currentCount(category)])
      .filter(([, count]) => count > 0)
      .map(([category, count]) => this.translate(category, count))

    this.displayTarget.value = parts.join(", ")
  }

  translate(category, count) {
    const entry = this.labelsValue[category] || {}
    const word = count === 1 ? entry.singular : entry.plural
    return `${count} ${word || ""}`.trim()
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
